import { AuditActionCode, AuditResourceType } from "@CommonUtils/AuditActionCodes";

export const AUDIT_ACTION_CODE_LABELS: Record<AuditActionCode, string> = {
  // Auth
  [AuditActionCode.AUTH_LOGIN]: "Login",
  [AuditActionCode.AUTH_FORGOT_PASSWORD]: "Forgot Password",
  [AuditActionCode.AUTH_RESET_PASSWORD]: "Reset Password",
  [AuditActionCode.AUTH_CHANGE_OWN_PASSWORD]: "Change Own Password",

  // SSO
  [AuditActionCode.SSO_LOGIN]: "SSO Login",
  [AuditActionCode.SSO_SWITCH_MERCHANT]: "SSO Switch Merchant",

  // Users
  [AuditActionCode.USERS_CREATE]: "Create User",
  [AuditActionCode.USERS_UPDATE]: "Update User",
  [AuditActionCode.USERS_RESET_PASSWORD]: "Reset User Password",
  [AuditActionCode.USERS_DELETE]: "Delete User",

  // Stores
  [AuditActionCode.STORES_CREATE]: "Create Store",
  [AuditActionCode.STORES_UPDATE]: "Update Store",
  [AuditActionCode.STORES_BIND_CATEGORIES]: "Bind Store Categories",
  [AuditActionCode.STORES_UPDATE_STATUS]: "Update Store Status",

  // Categories
  [AuditActionCode.CATEGORIES_CREATE]: "Create Category",
  [AuditActionCode.CATEGORIES_UPDATE]: "Update Category",
  [AuditActionCode.CATEGORIES_BIND_STORE]: "Bind Category to Store",
  [AuditActionCode.CATEGORIES_UPDATE_STATUS]: "Update Category Status",
  [AuditActionCode.CATEGORIES_UPDATE_FIXTURES_POG]: "Update Category Fixtures POG",

  // Store Summary
  [AuditActionCode.STORE_SUMMARY_IMPORT]: "Import Store Summary",

  // Inputs
  [AuditActionCode.INPUTS_UPDATE_PRODUCTS]: "Update Products",
  [AuditActionCode.INPUTS_UPDATE_MASTER_FIXTURE]: "Update Master Fixture",
  [AuditActionCode.INPUTS_UPDATE_STORE_PRODUCTS]: "Update Store Products",
  [AuditActionCode.INPUTS_UPDATE_STORE_PRODUCTS_CSV]: "Update Store Products (CSV)",
  [AuditActionCode.INPUTS_UPLOAD_PRODUCT_IMAGES]: "Upload Product Images",

  // Assortment distribution planner
  [AuditActionCode.ASSORTMENT_DISTRIBUTION_TARGETS_UPDATE]: "Update Distribution Targets",
  [AuditActionCode.ASSORTMENT_DISTRIBUTION_RUN]: "Run Distribution",
  [AuditActionCode.ASSORTMENT_DISTRIBUTION_SPACE_MIX_TARGETS_UPDATE]: "Update Space Mix Targets",

  // Merchflow
  [AuditActionCode.MERCHFLOW_DELETE]: "Delete Merchflow",
  [AuditActionCode.MERCHFLOW_REVIEW_CREATE]: "Create Merchflow Review",
  [AuditActionCode.MERCHFLOW_APPROVAL_UPDATE]: "Update Approval",
  [AuditActionCode.MERCHFLOW_PLANOGRAM_IMPORT]: "Import Planogram",
  [AuditActionCode.MERCHFLOW_HIGHLIGHT_BASE_POG_UPDATE]: "Update Base POG Highlight",
  [AuditActionCode.MERCHFLOW_HIGHLIGHT_STORE_POG_UPDATE]: "Update Store POG Highlight",
  [AuditActionCode.MERCHFLOW_BASE_POG_FAVOURITE_UPDATE]: "Update Base POG Favourite",
  [AuditActionCode.MERCHFLOW_EXPORT_BATCH_CREATE]: "Create Export Batch",
  [AuditActionCode.MERCHFLOW_STORE_POG_UPDATE]: "Update Store POG",
  [AuditActionCode.MERCHFLOW_STORE_POG_VALIDATE]: "Validate Store POG",
  [AuditActionCode.MERCHFLOW_BASE_POG_CREATE]: "Create Base POG",
  [AuditActionCode.MERCHFLOW_BASE_POG_TRIGGER]: "Trigger Base POG",
  [AuditActionCode.MERCHFLOW_BASE_POG_SAVE]: "Save Base POG",
  [AuditActionCode.MERCHFLOW_FILTER_CONFIG_UPDATE]: "Update Filter Config",
  [AuditActionCode.MERCHFLOW_FILTER_UPDATE]: "Update Filters",
  [AuditActionCode.MERCHFLOW_NOTES_UPDATE]: "Update Notes",
  [AuditActionCode.MERCHFLOW_APPLY_TO_BASES]: "Apply to Bases",
  [AuditActionCode.MERCHFLOW_APPLY_TO_BASES_COPY]: "Apply to Bases (Copy)",
  [AuditActionCode.MERCHFLOW_FLOW_UPDATE_TRIGGER]: "Trigger Flow Update",
  [AuditActionCode.MERCHFLOW_PSA_UPLOAD]: "Upload PSA",
  [AuditActionCode.MERCHFLOW_VARIANT_RESTRICTION_UPLOAD]: "Upload Variant Restrictions",
  [AuditActionCode.MERCHFLOW_S0_TRIGGER]: "Trigger S0",
  [AuditActionCode.MERCHFLOW_PLANOGRAM_TEMPLATE_CREATE]: "Create Planogram Template",
  [AuditActionCode.MERCHFLOW_S1_TRIGGER]: "Trigger S1",
  [AuditActionCode.MERCHFLOW_DUPLICATE]: "Duplicate Merchflow",
  [AuditActionCode.MERCHFLOW_STORE_POG_DELETE]: "Delete Store POG",
  [AuditActionCode.MERCHFLOW_STORE_POG_MARK_DELIVERED]: "Mark Store POG as Delivered",
  [AuditActionCode.MERCHFLOW_STORE_POG_BULK_MARK_DELIVERED]: "Mark All Store POGs as Delivered",

  // Projects
  [AuditActionCode.PROJECTS_CREATE]: "Create Project",
  [AuditActionCode.PROJECTS_UPDATE]: "Update Project",

  // Merchant Settings
  [AuditActionCode.MERCHANT_SETTINGS_UPDATE]: "Update Merchant Settings",
  [AuditActionCode.REPORT_POWERBI_WORKSPACE_CREATE]: "Create PowerBI Workspace",

  // Violation
  [AuditActionCode.VIOLATION_SCAN_TRIGGER]: "Trigger Violation Scan",

  // Import ETL
  [AuditActionCode.IMPORT_ETL_RUN]: "Run ETL Import",

  // JDA Baseline Import
  [AuditActionCode.JDA_BASELINE_IMPORT]: "Import JDA Baseline",

  // Fixtures Guessing
  [AuditActionCode.FIXTURES_GUESSING_TRIGGER]: "Trigger Fixtures Guessing",

  // POG Analysis
  [AuditActionCode.POG_ANALYSIS_GENERATE]: "Generate POG Analysis",

  // Simulation
  [AuditActionCode.SIMULATION_APPLY_UPDATE]: "Apply Update from Simulation",

  // Admin
  [AuditActionCode.ADMIN_MERCHANT_CREATE]: "Create Merchant (Admin)",
  [AuditActionCode.ADMIN_USER_SET_PASSWORD]: "Set User Password (Admin)",
};

export const AUDIT_RESOURCE_TYPE_LABELS: Record<AuditResourceType, string> = {
  [AuditResourceType.USER]: "User",
  [AuditResourceType.MERCHANT]: "Merchant",
  [AuditResourceType.MERCHANT_SETTINGS]: "Merchant Settings",
  [AuditResourceType.STORE]: "Store",
  [AuditResourceType.CATEGORY]: "Category",
  [AuditResourceType.STORE_CATEGORY]: "Store Category",
  [AuditResourceType.PRODUCT]: "Product",
  [AuditResourceType.STORE_PRODUCT]: "Store Product",
  [AuditResourceType.MASTER_FIXTURE]: "Master Fixture",
  [AuditResourceType.FLOW_REVIEW]: "Flow Review",
  [AuditResourceType.FILTER_CONFIG]: "Filter Config",
  [AuditResourceType.BASE_POG]: "Base POG",
  [AuditResourceType.STORE_POG]: "Store POG",
  [AuditResourceType.STORE_POG_TRIGGER]: "Store POG Trigger",
  [AuditResourceType.S0_TRIGGER]: "S0 Trigger",
  [AuditResourceType.S1_TRIGGER]: "S1 Trigger",
  [AuditResourceType.HIGHLIGHT]: "Highlight",
  [AuditResourceType.PROJECT]: "Project",
  [AuditResourceType.EXPORT_BATCH]: "Export Batch",
  [AuditResourceType.UPLOAD]: "Upload",
  [AuditResourceType.VIOLATION_SCAN]: "Violation Scan",
  [AuditResourceType.FIXTURE_GUESSING]: "Fixture Guessing",
  [AuditResourceType.VARIANT_RESTRICTION]: "Variant Restriction",
  [AuditResourceType.PRODUCT_IMAGE]: "Product Image",
  [AuditResourceType.PLANOGRAM_TEMPLATE]: "Planogram Template",
  [AuditResourceType.ETL_IMPORT]: "ETL Import",
  [AuditResourceType.APPROVAL]: "Approval",
  [AuditResourceType.NOTE]: "Note",
  [AuditResourceType.SESSION]: "Session",
  [AuditResourceType.SIMULATION]: "Simulation",
};
